/* 布局组件 */
import Layout from '@/page/layout'
// import fun
const _import = require('../_import')
// scope mangerPerformance
const scope = 'mangerPerformance'

export default {
  path: '/mangerPerformance',
  name: 'mangerPerformance',
  component: Layout,
  children: [{
    path: 'performance',
    name: 'performance',
    component: _import(`${scope}/performance`),
    meta: { title: '管家绩效', icon: '' }
  },
  {
    path: 'manage',
    name: 'manage',
    component: _import(`${scope}/manage`),
    meta: { title: '管家管理', icon: '' }
  },
  {
    path: 'housekeeperMonth',
    name: 'housekeeperMonth',
    component: _import(`report/housekeeperMonth`),
    meta: { title: '管家绩效(新)', icon: '' }
  },
  {
    path: 'tenantsBusiness',
    name: 'tenantsBusiness',
    component: _import(`report/tenantsBusiness`),
    meta: { title: '签约绩效', icon: '' }
  }, {
    path: 'investmentPerformance',
    name: 'investmentPerformance',
    component: _import(`report/investmentPerformance`),
    meta: { title: '投资绩效', icon: '' }
  }
  ]

}



// WEBPACK FOOTER //
// ./src/router/modules/mangerPerformance.js